<template>
	<div class="hidden h-16 w-full bg-[#e3e3e3] lg:block">
		<div class="mx-auto flex h-full w-full max-w-[1140px] items-center justify-between px-4">
			<div class="mr-auto flex items-center py-4">
				<OrganizationDropdown v-if="$org" class="pt-1" icon />
				<div class="ml-6 flex items-center gap-6 pt-1">
					<NuxtLink
						v-for="(link, label) in links"
						:key="label"
						:to="link"
						class="text-neutral-900 transition-colors hover:text-gray-900"
						exact-active-class="font-bold text-neutral-900"
						>{{ $t('link.' + label) }}</NuxtLink
					>
				</div>
			</div>
			<div class="flex items-center">
				<a
					v-if="$org"
					href="mailto:support@apropos.jobs"
					:title="$t('link.get-support-title')"
					class="flex items-center gap-1 pt-1 text-sm text-neutral-900 transition-colors hover:text-gray-900"
				>
					<Icon :icon="['far', 'phone']" />
					{{ $t('link.get-support') }}
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import { SubHeaderLinks } from '~/components/links'
import Icon from '~/components/ui/common/Icon'
import OrganizationDropdown from './OrganizationDropdown.vue'

export default {
	components: {
		OrganizationDropdown,
		Icon
	},
	data() {
		return {
			links: null
		}
	},
	created() {
		this.links = SubHeaderLinks
	}
}
</script>
